import { render, staticRenderFns } from "./OutsourcingPage.vue?vue&type=template&id=776cee60&"
import script from "./OutsourcingPage.vue?vue&type=script&lang=js&"
export * from "./OutsourcingPage.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports